





























































































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { IAuditResult } from 'simple-apostille-v2';
import {
  Address,
  Account,
  MultisigAccountModificationTransaction,
  Deadline,
  AggregateTransaction,
  UInt64, HashLockTransaction,
  Mosaic,
  MosaicId,
  RepositoryFactoryHttp,
  TransactionService,
  PublicAccount,
} from 'symbol-sdk';
import AppConfig from '../../libs/AppConfig';

@Component({})

export default class OwnerEditModal extends Vue {
  @Prop()
  public cosignatories!: Address[];

  @Prop()
  public closeOwnerDialog!: Function;

  @Prop()
  public auditResult!: IAuditResult;

  private apostilleAccount!: PublicAccount;

  private newCosignatories: Address[] = [];

  private addCosignatories: Address[] = [];

  private removeCosignatories: Address[] = [];

  private newSCosignatories: string[] = [];

  private sCosignatories: string[] = [];

  private tmpOwner = '';

  private signerKey = '';

  private signerAddress = '';

  private epochAdjustment = AppConfig.epochAdjustment();

  private networkType = AppConfig.networkType();

  private generationHash = AppConfig.generationHash();

  private apiEndpoint = AppConfig.apiEndpoint();

  private isLoading = false;

  mounted() {
    this.newCosignatories = [...this.cosignatories];
    this.cosignatories.forEach((cos) => {
      this.sCosignatories.push(cos.plain());
    });
    this.newSCosignatories = [...this.sCosignatories];
    this.createRepositoryFactory();
    this.createTransactionSerivce();

    const accountHttp = this.createRepositoryFactory().createAccountRepository();
    const addr = this.auditResult.apostilleAccount;
    if (addr) {
      accountHttp.getAccountInfo(addr).subscribe(
        (info) => {
          this.apostilleAccount = PublicAccount
            .createFromPublicKey(info.publicKey, this.networkType);
        },
        (err) => console.log(err),
      );
    }
  }

  private onClickAddOwner() {
    const addr = Address.createFromRawAddress(this.tmpOwner);
    let flag = true;

    this.newCosignatories.forEach((cos) => {
      if (cos.plain() === addr.plain()) {
        flag = false;
      }
    });

    if (flag) {
      let addFlag = true;
      this.cosignatories.forEach((cos) => {
        if (cos.plain() === addr.plain()) {
          addFlag = false;
        }
      });

      if (addFlag) {
        this.addCosignatories.push(addr);
      } else {
        this.removeCosignatories = this.removeCosignatories
          .filter((cos) => cos.plain() !== addr.plain());
      }
      this.newCosignatories.push(addr);
      this.newSCosignatories.push(addr.plain());
    }

    this.tmpOwner = '';
  }

  private onClickRemoveOwner(index: number, addr: Address) {
    this.newCosignatories.splice(index, 1);
    this.newSCosignatories.splice(index, 1);

    let removeFlag = false;
    this.cosignatories.forEach((cos) => {
      if (cos.plain() === addr.plain()) {
        removeFlag = true;
      }
    });

    if (removeFlag) {
      this.removeCosignatories.push(addr);
    } else {
      this.addCosignatories = this.addCosignatories.filter((cos) => cos.plain() !== addr.plain());
    }
  }

  private onClickSubmit() {
    let flag = false;

    this.sCosignatories.forEach((cos) => {
      if (!this.newSCosignatories.includes(cos)) {
        flag = true;
      }
    });
    this.newSCosignatories.forEach((cos) => {
      if (!this.sCosignatories.includes(cos)) {
        flag = true;
      }
    });

    if (!flag) return;

    const diff = this.addCosignatories.length - this.removeCosignatories.length;

    const transactions: MultisigAccountModificationTransaction[] = [];

    // 今回の変更によって連署者の数が3人を超えたかのフラグ
    const isOverStepThreePlus = (this.cosignatories.length < 3) // 変化前の連署者が3人未満
    && ((this.cosignatories.length + diff) >= 3); // 変化後の連署者が3人以上

    const isOverStepThreeMinus = (this.cosignatories.length >= 3) // 変化前の連署者が3人以上
    && ((this.cosignatories.length + diff) < 3); // 変化後の連署者が3人未満

    if (diff < 0) {
      transactions.push(
        MultisigAccountModificationTransaction.create(
          Deadline.create(this.epochAdjustment),
          diff - (isOverStepThreePlus ? 1 : 0) + (isOverStepThreeMinus ? 1 : 0),
          diff - (isOverStepThreePlus ? 1 : 0) + (isOverStepThreeMinus ? 1 : 0),
          [],
          [],
          this.networkType,
        ),
      );
    }

    if (this.addCosignatories.length !== 0) {
      const addTrandaction = MultisigAccountModificationTransaction.create(
        Deadline.create(this.epochAdjustment),
        0,
        0,
        this.addCosignatories,
        [],
        this.networkType,
      );
      transactions.push(addTrandaction);
    }

    if (diff > 0) {
      transactions.push(
        MultisigAccountModificationTransaction.create(
          Deadline.create(this.epochAdjustment),
          diff - (isOverStepThreePlus ? 1 : 0) + (isOverStepThreeMinus ? 1 : 0),
          diff - (isOverStepThreePlus ? 1 : 0) + (isOverStepThreeMinus ? 1 : 0),
          [],
          [],
          this.networkType,
        ),
      );
    }
    this.removeCosignatories.forEach((cos) => {
      transactions.push(
        MultisigAccountModificationTransaction.create(
          Deadline.create(this.epochAdjustment),
          0,
          0,
          [],
          [cos],
          this.networkType,
        ),
      );
    });

    const agtxs = transactions.map((tx) => tx.toAggregate(this.apostilleAccount));

    const aggregateTransaction = AggregateTransaction.createBonded(
      Deadline.create(this.epochAdjustment),
      agtxs,
      this.networkType,
      [],
      UInt64.fromUint(2000000),
    );

    const signer = Account.createFromPrivateKey(
      this.signerKey,
      this.networkType,
    );

    const signedTransaction = signer.sign(
      aggregateTransaction,
      this.generationHash,
    );
    const mosaic = new Mosaic(
      new MosaicId('091F837E059AE13C'),
      UInt64.fromUint(10000000),
    );
    const hashLockTransaction = HashLockTransaction.create(
      Deadline.create(this.epochAdjustment),
      mosaic,
      UInt64.fromUint(480),
      signedTransaction,
      this.networkType,
      UInt64.fromUint(2000000),
    );

    const signedHashLockTransaction = signer.sign(
      hashLockTransaction,
      this.generationHash,
    );

    const transactionService = this.createTransactionSerivce();
    const listener = this.createListener();

    this.isLoading = true;

    if (transactionService && listener) {
      listener.open().then(() => {
        transactionService.announceHashLockAggregateBonded(
          signedHashLockTransaction,
          signedTransaction,
          listener,
        ).subscribe((x) => {
          listener.close();
          this.isLoading = false;
        }, (err) => {
          console.log(err);
          this.isLoading = false;
        });
      }).catch((err) => {
        console.error(err);
        listener.close();
        this.isLoading = false;
      });
    }
  }

  private cosinatoryLink(a: Address) {
    return `http://explorer.testnet.symboldev.network/transactions/${a.plain()}`;
  }

  private onChange(val: string) {
    const netType = AppConfig.networkType();
    this.signerKey = val;
    this.signerAddress = Account.createFromPrivateKey(val, netType).address.pretty();
  }

  private createRepositoryFactory() {
    return (new RepositoryFactoryHttp(
      AppConfig.apiEndpoint(), {
        generationHash: AppConfig.generationHash(),
        networkType: this.networkType,
        websocketUrl: `${AppConfig.apiEndpoint().replace('http', 'ws')}/ws`,
        websocketInjected: WebSocket,
      },
    ));
  }

  private createTransactionSerivce() {
    const repositoryFactory = this.createRepositoryFactory();
    if (repositoryFactory) {
      return new TransactionService(
        repositoryFactory.createTransactionRepository(),
        repositoryFactory.createReceiptRepository(),
      );
    }

    return null;
  }

  private createListener() {
    const repositoryFactory = this.createRepositoryFactory();
    if (repositoryFactory) {
      return repositoryFactory.createListener();
    }

    return null;
  }
}

